/**
 * 公共事業場一覧
 */
import * as httpConst from '../../../../constants/httpConst'
import Vue from 'vue'
import * as types from '../../../mutation-types/driver-types'

const API_PATH = `${httpConst.DRIVER_ENDPOINT}/transfers/public_place_complements`

/**
 */
const getDefaultState = () => {
  return {
  }
}

const public_place_complement = {
  namespaced: true,
  state: getDefaultState(),
  getters: {
    hasResult: ( state ) => {
      return (state.pagination.total_count > 0)
    },
  },
  actions: {
    /**
     * 公共事業場一覧
     * @param commit
     * @param params
     * @param page
     * @param limit
     * @return {Promise<unknown>}
     */
     index ({ commit }, { params }) {
      return new Promise((resolve) => {
        Vue.$http.get(API_PATH, { params: params }).then(data => {
          let content = data.content
          resolve(content)
        })
      })
    },
  },
  mutations: {
  },
}

export default public_place_complement
